@if ('MOBILE_ONLY' !== type()) {
  <webmodule-order-panel (showContentChange)="showSelected.set($event)"
                         [canCollapse]="isLoaded()"
                         [showContent]="showSelected()">
    <ng-container heading>
      <h3 class="mb-0" [innerHTML]="index() + '. ' + ('block.phone.heading' | translate) "></h3>
    </ng-container>
    <ng-container content>

      @if (isLoaded()) {
        <div [innerHtml]="'block.phone.description' | translate" class="wysiwyg"></div>

        @if(hasTranslationForKey('block.phone.more-information')) {
          <div><button (click)="openModal('block.phone.heading', 'block.phone.more-information')" class="btn link">{{ 'common.button.more-info' | translate }}</button></div>
        }
      } @else {
        <webmodule-order-skeleton-screen [pulse]="isLoading()" type="TEXT_BLOCK" />
      }

      <fieldset>
        <legend class="sr-only">{{ 'block.phone.heading' | translate }}</legend>
        <div class="grid gap-4">
          @if (isLoaded()) {
            @for (item of phoneLandline; track item) {
              <webmodule-order-input-panel (selected)="setSelected(item, 'landline')"
                                           [checked]="item === select()"
                                           [price]="item.price"
                                           [priceAlt]="item.id === 'withLandline' ? ('common.label.included' | translate) : ''"
                                           [ref]="item.id"
                                           groupName="landline">
                <ng-container label>{{ item.label ?? item.name }}</ng-container>
              </webmodule-order-input-panel>
            }

            @if (select()?.disc === 'withLandline') {
              <ng-container *ngTemplateOutlet="showPhoneOptions"></ng-container>
            }
          } @else {
            <webmodule-order-skeleton-screen [pulse]="isLoading()" />
            <webmodule-order-skeleton-screen [pulse]="isLoading()" />
          }
        </div>

        <ng-template #showPhoneOptions>
          <div class="border-t w-full mt-6 pb-2"></div>

          <fieldset class="pb-0">
            <legend class="sr-only">{{ 'block.phone.number-porting.title' | translate }}</legend>
            <div class="grid gap-4 py-4">
              <h4>{{ 'block.phone.number-porting.title' | translate }}</h4>
              @if(hasTranslationForKey('block.phone.number-porting.more-information')) {
                <div><button (click)="openModal('block.phone.number-porting.title', 'block.phone.number-porting.more-information')" class="btn link">{{ 'common.button.more-info' | translate }}</button></div>
              }
              @if (getOptionByTag('number_porting'); as item) {
                <webmodule-order-input-panel (selected)="setPackageState(item, 'numberPorting')"
                                             [checked]="isPhoneOptionsSelected(item.id, 'numberPorting')"
                                             [price]="item.price"
                                             [ref]="item.id"
                                             [discount]="getDiscountById(item.id)"
                                             [isOneTimePayment]="'oneTime'===camelCase(item.paymentFrequency)"
                                             groupName="numberPorting"
                                             inputType="radio">
                  <ng-container label>{{ item.label || item.name }}</ng-container>
                  <ng-container content>
                    @if (item.description) {
                      <p class="col-span-2">{{ item.description }}</p>
                    }

                    @if (isPhoneOptionsSelected(item.id, 'numberPorting')) {
                      <div [formGroup]="form" class="input-group col-span-2 mt-2">
                          <label class="sr-only label" for="phoneNumber">{{ 'block.phone.input.phone-number.label' | translate }}</label>
                          <div>
                            <input class="control"
                                   formControlName="phoneNumber"
                                   id="phoneNumber"
                                   name="phoneNumber"
                                   [placeholder]="'block.phone.input.phone-number.placeholder' | translate"
                                   type="text">
                          </div>
                        @if (form.get('phoneNumber')?.invalid && form.get('phoneNumber')?.touched) {
                          <span class="text-sm text-red-600">{{ 'block.phone.input.phone-number.invalid' | translate }}</span>
                        }
                        </div>
                    }
                  </ng-container>
                </webmodule-order-input-panel>
              }

              @if (getOptionByTag('phone_new_number'); as item) {
                <webmodule-order-input-panel (selected)="selectOptionAndClearPhoneNumber('phoneNumber', item, 'numberPorting')"
                                             [checked]="isPhoneOptionsSelected(item.id, 'numberPorting')"
                                             [price]="item.price"
                                             [ref]="item.id"
                                             [discount]="getDiscountById(item.id)"
                                             [isOneTimePayment]="'oneTime'===camelCase(item.paymentFrequency)"
                                             groupName="numberPorting"
                                             inputType="radio">
                  <ng-container label>{{ item.label || item.name }}</ng-container>
                  <ng-container content>
                    @if (item.description) {
                      <p class="col-span-2">{{ item.description }}</p>
                    }
                  </ng-container>
                </webmodule-order-input-panel>
              }
            </div>
          </fieldset>

          @if (getOptionByTag('phone_unlimited_nl') || getOptionByTag('phone_unlimited_eu')) {
            <fieldset class="pb-0">
              <legend class="sr-only">{{ 'block.phone.phone-unlimited.title' | translate }}</legend>
              <div class="grid gap-4">
                <h4>{{ 'block.phone.phone-unlimited.title' | translate }}</h4>
                @if(hasTranslationForKey('block.phone.phone-unlimited.more-information')) {
                  <div><button (click)="openModal('block.phone.phone-unlimited.title', 'block.phone.phone-unlimited.more-information')" class="btn link">{{ 'common.button.more-info' | translate }}</button></div>
                }

                @if (getOptionByTag('phone_unlimited_nl'); as item) {
                  <webmodule-order-input-panel (selected)="setPackageState(item, 'phoneUnlimited', false)"
                                               [checked]="isPhoneOptionsSelected(item.id, 'phoneUnlimited')"
                                               [price]="item.price"
                                               [ref]="item.id"
                                               [discount]="getDiscountById(item.id)"
                                               [isOneTimePayment]="'oneTime'===camelCase(item.paymentFrequency)"
                                               groupName="phoneUnlimited"
                                               visualType="switch"
                                               inputType="checkbox">
                    <ng-container label>{{ item.label || item.name }}</ng-container>
                    <ng-container content>
                      @if (item.description) {
                        <p class="col-span-2">{{ item.description }}</p>
                      }
                    </ng-container>
                  </webmodule-order-input-panel>
                }

                @if (getOptionByTag('phone_unlimited_eu'); as item) {
                  <webmodule-order-input-panel (selected)="setPackageState(item, 'phoneUnlimited', false)"
                                               [checked]="isPhoneOptionsSelected(item.id, 'phoneUnlimited')"
                                               [price]="item.price"
                                               [ref]="item.id"
                                               [discount]="getDiscountById(item.id)"
                                               [isOneTimePayment]="'oneTime'===camelCase(item.paymentFrequency)"
                                               groupName="phoneUnlimited"
                                               visualType="switch"
                                               inputType="checkbox">
                    <ng-container label>{{ item.label || item.name }}</ng-container>
                    <ng-container content>
                        @if (item.description) {
                          <p class="col-span-2">{{ item.description }}</p>
                        }
                    </ng-container>
                  </webmodule-order-input-panel>
                }

              </div>
            </fieldset>
          }

          @if (getOptionByTag('phone_extra_line'); as item) {
            <fieldset class="pb-0">
              <legend class="sr-only">{{ 'block.phone.second-line.title' | translate }}</legend>
              <div class="grid gap-4 py-4">
                <h4>{{ 'block.phone.second-line.title' | translate }}</h4>

                @if(hasTranslationForKey('block.phone.second-line.more-information')) {
                  <div><button (click)="openModal('block.phone.second-line.title', 'block.phone.second-line.more-information')" class="btn link">{{ 'common.button.more-info' | translate }}</button></div>
                }
                <webmodule-order-input-panel (selected)="setExtraPhoneLineState(item,'extraPhoneLine', false)"
                                             [checked]="isPhoneOptionsSelected(item.id, 'extraPhoneLine')"
                                             [price]="item.price"
                                             [ref]="item.id"
                                             [discount]="getDiscountById(item.id)"
                                             [isOneTimePayment]="'oneTime'===camelCase(item.paymentFrequency)"
                                             groupName="phoneExtraLine"
                                             visualType="switch"
                                             inputType="checkbox">
                  <ng-container label>{{ item.label || item.name }}</ng-container>
                  <ng-container content>
                    @if (item.description) {
                      <p class="col-span-2">{{ item.description }}</p>
                    }
                  </ng-container>
                </webmodule-order-input-panel>

                @if (isPhoneOptionsSelected(item.id, 'extraPhoneLine');) {
                  @if (getOptionByTag('phone_extra_number_porting'); as item) {
                    <webmodule-order-input-panel (selected)="setPackageState(item, 'extraNumberPorting')"
                                                 [checked]="isPhoneOptionsSelected(item.id, 'extraNumberPorting')"
                                                 [price]="item.price"
                                                 [ref]="item.id"
                                                 [discount]="getDiscountById(item.id)"
                                                 [isOneTimePayment]="'oneTime'===camelCase(item.paymentFrequency)"
                                                 groupName="numberPortingExtraLine"
                                                 inputType="radio">
                    <ng-container label>{{ item.label || item.name }} {{ camelCase(item.paymentFrequency) }}</ng-container>
                    <ng-container content>
                        @if (item.description) {
                          <p class="col-span-2">{{ item.description }}</p>
                        }

                        @if (isPhoneOptionsSelected(item.id, 'extraNumberPorting')) {
                          <div [formGroup]="form" class="input-group col-span-2 mt-2">
                              <label class="sr-only label" for="phoneNumberExtra">{{ 'block.phone.input.phone-number.label' | translate }}</label>
                              <div>
                                <input class="control"
                                       formControlName="secondPhoneNumber"
                                       id="phoneNumberExtra"
                                       name="phoneNumberExtra"
                                       [placeholder]="'block.phone.input.phone-number.placeholder' | translate"
                                       type="text">
                              </div>
                            @if (form.get('phoneNumberExtra')?.invalid && form.get('phoneNumberExtra')?.touched) {
                              <span class="text-sm text-red-600">{{ 'block.phone.input.phone-number.invalid' | translate }}</span>
                            }
                            </div>
                        }
                      </ng-container>
                    </webmodule-order-input-panel>
                  }

                  @if (getOptionByTag('phone_new_extra_line'); as item) {
                    <webmodule-order-input-panel (selected)="selectOptionAndClearPhoneNumber('secondPhoneNumber', item, 'extraNumberPorting')"
                                                 [checked]="isPhoneOptionsSelected(item.id, 'extraNumberPorting')"
                                                 [price]="item.price"
                                                 [ref]="item.id"
                                                 [discount]="getDiscountById(item.id)"
                                                 [isOneTimePayment]="'oneTime'===camelCase(item.paymentFrequency)"
                                                 groupName="numberPortingExtraLine"
                                                 inputType="radio">
                    <ng-container label>{{ item.label || item.name }}</ng-container>
                    <ng-container content>
                      @if (item.description) {
                        <p class="col-span-2">{{ item.description }}</p>
                      }
                    </ng-container>
                    </webmodule-order-input-panel>
                  }
                }
              </div>
            </fieldset>
          }
        </ng-template>
      </fieldset>
    </ng-container>
    @if (isLoaded()) {
      <ng-container altContent>
        @if (getSelected(); as selected) {
          <div class="grid grid-cols-2 border-t pt-4">
            <div class="h5 mb-0">{{ selected.name }}</div>
            <div class="h5 mb-0 text-right row-span-2">
              {{ selected.price ? (selected.price | currency:'EUR') + '/maand' : '' }}
            </div>
          </div>
        }
      </ng-container>
    }
  </webmodule-order-panel>
}
